import { Fetch } from 'lib';
import type { PaymentGateway } from 'types';

type RequestResponses = PaymentGateway;

type RequestParameters = {
  id: string;
};

type RequestBody = StrictOmit<PaymentGateway, 'id' | 'type'>;

const updatePaymentGateway = async (
  params: RequestParameters,
  body: RequestBody,
) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminPaymentGateway/updatePaymentGateway',
    method: 'PUT',
    params,
    body,
  });

export { updatePaymentGateway };
